import { SaveProveedor } from "../../shared/components/saveGroupProveedores";

export interface CreateGroupProveedorPageInterface {}

const CreateGroupProveedorPage: React.FC<CreateGroupProveedorPageInterface> = () => {
  return <SaveProveedor titlePage="Crear Grupo Proveedores" />;
};

export default CreateGroupProveedorPage;